import o from "clipper-lib";
import { pathToPoly as f } from "./internal/index.js";
import { polyToPath as p } from "./internal/index2.js";
import { alignPolygons as a } from "./index.js";
const n = 1e5;
function h(e, l) {
  const r = new o.ClipperOffset(), s = e[0][1], i = p(e);
  o.JS.ScaleUpPath(i, n), r.AddPath(i, o.JoinType.jtMiter, o.EndType.etClosedPolygon);
  const t = [];
  if (r.Execute(t, l * n), !t[0])
    return [];
  o.JS.ScaleDownPath(t[0], n);
  const c = f(t[0], s);
  return a(e, c);
}
export {
  h as offsetPolygon
};
//# sourceMappingURL=index5.js.map
